<template>
  <div class="explain-checklist">
    <div class="explain-checklist__header-wrapper">
      <BackButton />
      <h3 class="title text-2xl">
        {{ $t('Done inspections matching with your selected criteria') }}
      </h3>
    </div>
    <Card class="px-4">
      <table class="table w-full" cellpadding="0" cellspacing="0">
        <thead>
        <th class="text-left">
          {{ $t('Conducted at') }}
        </th>
        <th class="text-left">
          {{ $t('Checklist title') }}
        </th>
        <th class="text-left">
          {{ $t('Entity item') }}
        </th>
        <th class="text-left">
          {{ $t('Conducted by') }}
        </th>
        </thead>
        <tbody>
        <tr
          v-for="(inspection, index) in inspections"
          :key="index"
          class="cursor-pointer"
          @click="$router.push({name: 'inspectionDetail', params: { id: String(inspection.id) }})"
        >
          <td>
            {{ formatConductedAt(inspection.conducted_at) }}
          </td>
          <td>
            {{ inspection.title }}
          </td>
          <td>
            {{ inspection.entity_item }}
          </td>
          <td>
            {{ inspection.user }}
          </td>
        </tr>
        </tbody>
      </table>

      <pagination-links
        :has-previous-pages="hasPreviousPage"
        :has-more-pages="hasNextPage"
        @previous="selectPreviousPage"
        @next="selectNextPage"
      />
    </Card>
  </div>
</template>

<script>
  import Card from '@/_legacy/components/Card.vue';
  import PaginationLinks from '@/_legacy/components/PaginationLinks.vue';
  import Paginatable from '@/_legacy/mixins/Paginatable';
  import InteractsWithQueryString from '@/_legacy/laravel-nova/InteractsWithQueryString';
  import { du } from '@/ui/i18n/i18n';
  import { BackButton } from '@/ui/components/button/BackButton';

  export default {
    name: 'ExplainChecklist',
    components: {
      Card,
      PaginationLinks,
      BackButton
    },
    mixins: [
      Paginatable,
      InteractsWithQueryString,
    ],
    props: {
      record: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        inspections: [],
        response: '',
        uuid: '',
        type: '',
        hasPreviousPage: false,
        hasNextPage: false,
      };
    },
    computed: {
      query() {
        return {
          ...this.page !== this.defaultPage && { [this.pageParameter]: this.page },
          ...this.perPage !== this.defaultPerPage && { [this.perPageParameter]: this.perPage },
          ...this.uuid !== undefined && { uuid: this.uuid },
          ...this.type !== undefined && { type: this.type },
          ...this.response !== undefined && { response: this.response },
        };
      },
      requestQueryString() {
        return {
          perPage: this.perPage,
          page: this.page,
          uuid: this.uuid,
          type: this.type,
          response: this.response,
        };
      },
    },
    created() {
      this.getResults();

      this.initializePaginationFromQueryString();
      this.$watch(
        () => ([
          this.page,
          this.perPage,
        ].join(',')),
        () => {
          this.replaceQueryString(this.query);
          this.getResults();
        },
      );
    },
    methods: {
      formatConductedAt(conductedAt) {
        return du(conductedAt, 'shortDateTime');
      },
      getResults() {
        this.setPagination(this.record.links);
        this.inspections = this.record.data;
      },
    },
  };
</script>
